var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "coaching-core-data" }, [
    _c(
      "div",
      { staticClass: "title-1", staticStyle: { "margin-bottom": "15px" } },
      [_vm._v("心理辅导核心数据")]
    ),
    _c(
      "div",
      { staticClass: "data-list flex-around-center" },
      _vm._l(_vm.dataSource, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "list-item flex-column",
            staticStyle: { "align-items": "center" },
          },
          [
            _c("img", {
              staticStyle: { width: "48px", height: "48px" },
              attrs: {
                src: require(`@/assets/imgs/school/monthRecord/${item.icon}.png`),
                alt: "",
              },
            }),
            _c("div", { staticStyle: { margin: "10px 0" } }, [
              _vm._v(_vm._s(item.label)),
            ]),
            _c(
              "div",
              [
                _c("CountAnimation", {
                  staticClass: "count-bold",
                  attrs: { "end-val": Number(item.value) },
                }),
                _c("span", [_vm._v(_vm._s(index === 0 ? "%" : "次"))]),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }